<mat-dialog-actions>
  <button class="closedialog" (click)="closeDialog(false)">
    <i class="material-icons">close</i>
  </button>
</mat-dialog-actions>


<mat-card-content>
  <div class="mat-card-title">
    <h3 style="color:red"> {{DialogueData.Title}}</h3>
  </div>
  <br /><br />
  <div class="mat-card-body">
    <B> {{DialogueData.Description}}</B>
  </div>
  <div class="customDialog" >
    <button *ngIf="!DialogueData.removeUser"  style="margin:10px" mat-raised-button (click)="onConfirmClick(DialogueData.UniqueId)">OK</button>
    <button *ngIf="DialogueData.removeUser" (click)="closeDialog(true)"   style="margin:10px" mat-raised-button>OK</button>
    <button   mat-stroked-button (click)="closeDialog(false)">Cancel</button>
  </div>

</mat-card-content>
